<ng-container *transloco="let t; prefix: 'scDiscoveryErrorDialog'">
	<div class="sh-dialog-container sh-discovery-error-dialog-container" fxLayout="column">
		<mat-dialog-title fxLayout="column" fxLayoutAlign="start center">
			<h1 class="sh-discovery-error-title">
				{{ t('discovery-error-dialog-title') }}
			</h1>
		</mat-dialog-title>
		<mat-dialog-content class="sh-dialog-content" fxLayout="column" fxLayoutAlign="start">
			<h4 class="sh-discovery-error-title">
				{{ t('discovery-error-dialog-try') }}
			</h4>
			<ul class="sh-dialog-ul">
				<li>{{ t('discovery-error-dialog-content') }}</li>
			</ul>
		</mat-dialog-content>
		<mat-dialog-content class="sh-dialog-content" fxLayout="column" fxLayoutAlign="start">
			<h4 class="sh-discovery-error-title">
				{{ t('discovery-error-dialog-support') }}
			</h4>
		</mat-dialog-content>

		<mat-dialog-actions mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
			<prism-button id="sh-discovery-error-close-button" color="accent" (click)="close()">
				{{ t('close') }}
			</prism-button>
		</mat-dialog-actions>
	</div>
</ng-container>
